
import "./loginui.css";

import React, { useState } from "react";
import {
  Button,
  InputAdornment,
  TextField,
  CircularProgress,
  Box,
} from "@mui/material";

import LockIcon from "Media/icons/awesome-lock.svg";
import MailIcon from "Media/icons/social-email.svg";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import logo from "Media/Amnius_connect_with_text.png";

const LoginUI = ({ verify }) => {
  const [visibility, setVisibility] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await verify(email, password);
    } catch (error) {
      console.error("Login failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
  };

  const togglePasswordVisibility = () => {
    setVisibility((prev) => !prev);
  };

  return (
    <div className="login-container">
      <div className="login-wrapper">
        <div className="login-upper">
          <div className="login-logo">
            <img src={logo} alt="Amnius logo" />
          </div>
        </div>

        <div className="login-below">
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="login-email">
              <TextField
                fullWidth
                required
                value={email}
                label="Email"
                variant="outlined"
                type="email"
                onChange={handleEmail}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <img src={MailIcon} alt="Email" />
                      </InputAdornment>
                    ),
                  },
                }}
              />
            </div>

            <div className="login-password">
              <TextField
                fullWidth
                required
                value={password}
                label="Password"
                type={visibility ? "password" : "text"}
                onChange={handlePassword}
                autoComplete="current-password"
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <img src={LockIcon} alt="Password" />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <button
                          type="button"
                          onClick={togglePasswordVisibility}
                          aria-label={
                            visibility
                              ? "Show password"
                              : "Hide password"
                          }
                          style={{
                            border: "none",
                            background: "transparent",
                            padding: 0,
                            margin: 0,
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            color: "inherit",
                          }}
                        >
                          {visibility ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </button>
                      </InputAdornment>
                    ),
                  },
                }}
              />
            </div>

            <div className="login-btn">
              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={loading}
                sx={{
                  backgroundColor: "#446fa2",
                  height: 45,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "&:hover": {
                    backgroundColor: "#3b5e8a",
                  },
                }}
              >
                {loading ? (
                  <Box
                    sx={{
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress
                      size={24}
                      thickness={5}
                      sx={{ color: "white" }}
                    />
                  </Box>
                ) : (
                  "LOGIN"
                )}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginUI;